<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Blog" pageTitle="Blog" />
            <BlogContent />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import BlogContent from '../Blog/BlogContent'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'BlogPage',
    components: {
        MainHeader,
        PageTitle,
        BlogContent,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>